import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import BookingPage from './pages/BookingPage';
import TicketPage from './pages/TicketPage';
import AdminLogin from './admin/AdminLogin';
import AdminLayout from './admin/AdminLayout';
import AdminDashboard from './admin/AdminDashboard';
import AdminTicketList from './admin/AdminTicketList';
import AdminTicketDetail from './admin/AdminTicketDetail';
import AdminScan from './admin/AdminScan';
import AdminCoupons from './admin/AdminCoupons';
import AdminGallery from './admin/AdminGallery';
import AdminSettings from './admin/AdminSettings';
import AdminUsers from './admin/AdminUsers';

function useRole() {
  return localStorage.getItem('als_admin_role') || '';
}

function AuthGuard({ children }) {
  const token = localStorage.getItem('als_admin_token');
  if (!token) return <Navigate to="/admin/login" replace />;
  return children;
}

function AdminOnlyGuard({ children }) {
  const token = localStorage.getItem('als_admin_token');
  const role = useRole();
  if (!token) return <Navigate to="/admin/login" replace />;
  if (role !== 'admin') return <Navigate to="/admin/scan" replace />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/book" element={<BookingPage />} />
        <Route path="/ticket/:ticketNumber" element={<TicketPage />} />
        <Route path="/admin/login" element={<AdminLogin />} />

        <Route path="/admin" element={<AuthGuard><AdminLayout /></AuthGuard>}>
          <Route index element={<Navigate to="/admin/scan" replace />} />

          {/* Admin-only routes */}
          <Route path="dashboard" element={<AdminOnlyGuard><AdminDashboard /></AdminOnlyGuard>} />
          <Route path="coupons" element={<AdminOnlyGuard><AdminCoupons /></AdminOnlyGuard>} />
          <Route path="gallery" element={<AdminOnlyGuard><AdminGallery /></AdminOnlyGuard>} />
          <Route path="settings" element={<AdminOnlyGuard><AdminSettings /></AdminOnlyGuard>} />
          <Route path="users" element={<AdminOnlyGuard><AdminUsers /></AdminOnlyGuard>} />

          {/* Staff + Admin routes */}
          <Route path="tickets" element={<AdminTicketList />} />
          <Route path="tickets/:id" element={<AdminTicketDetail />} />
          <Route path="scan" element={<AdminScan />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
